import { MITTEILUNG_ANTWORT } from '../api/apiClient';

/**
 * Antwortmöglichkeiten zu einer Mitteilung bzw. einem Termin.
 *
 * Verlangt der Termin eine Zu-/Absage, erscheinen zwei Schaltflächen, sonst
 * nur die Kenntnisnahme. Die bereits gegebene Antwort ist hervorgehoben und
 * lässt sich durch Anklicken der anderen ändern.
 */
function MitteilungAntwortAktionen({ mitteilung, onAntwort, laufend = false, klein = false }) {
  const groesse = klein ? 'btn-sm' : '';
  const aktuell = mitteilung?.antwort ?? null;

  if (mitteilung?.zusageErforderlich) {
    return (
      <div className="flex flex-wrap items-center gap-2">
        <button
          className={`btn ${groesse} ${aktuell === MITTEILUNG_ANTWORT.ZUGESAGT ? 'btn-primary' : 'btn-secondary'}`}
          onClick={() => onAntwort(MITTEILUNG_ANTWORT.ZUGESAGT)}
          disabled={laufend}
        >
          {laufend && <span className="spinner" />}
          Zusagen
        </button>
        <button
          className={`btn ${groesse} ${aktuell === MITTEILUNG_ANTWORT.ABGESAGT ? 'btn-danger' : 'btn-secondary'}`}
          onClick={() => onAntwort(MITTEILUNG_ANTWORT.ABGESAGT)}
          disabled={laufend}
        >
          Absagen
        </button>
      </div>
    );
  }

  if (aktuell) return null;

  return (
    <button
      className={`btn btn-primary ${groesse}`}
      onClick={() => onAntwort(MITTEILUNG_ANTWORT.GELESEN)}
      disabled={laufend}
    >
      {laufend && <span className="spinner" />}
      Zur Kenntnis genommen
    </button>
  );
}

/** Badge zum aktuellen Antwortstand eines Eintrags. */
export function MitteilungAntwortBadge({ mitteilung }) {
  switch (mitteilung?.antwort) {
    case MITTEILUNG_ANTWORT.ZUGESAGT:
      return <span className="badge badge-green">Zugesagt</span>;
    case MITTEILUNG_ANTWORT.ABGESAGT:
      return <span className="badge badge-red">Abgesagt</span>;
    case MITTEILUNG_ANTWORT.GELESEN:
      return <span className="badge badge-green">Bestätigt</span>;
    default:
      return (
        <span className="badge badge-amber">
          {mitteilung?.zusageErforderlich ? 'Rückmeldung offen' : 'Neu'}
        </span>
      );
  }
}

export default MitteilungAntwortAktionen;
